import React from 'react';
import ResetPasswordForm from '../components/auth/ResetPasswordForm';

const ResetPasswordPage: React.FC = () => {
  return (
    <div className="auth-page">
      {/* Grid Overlay */}
      <div className="grid-overlay"></div>
      
      {/* Horizon Line */}
      <div className="horizon"></div>
      
      {/* Speed Lines */}
      <div className="speed-lines">
        <div className="speed-line"></div>
        <div className="speed-line"></div>
        <div className="speed-line"></div>
        <div className="speed-line"></div>
      </div>
      
      {/* Wireframe Supercar */}
      <div className="supercar-wireframe">
        <div className="car-body">
          <div className="car-highlight"></div>
        </div>
        <div className="car-hood"></div>
        <div className="car-window"></div>
        <div className="car-front"></div>
        <div className="car-back"></div>
        <div className="wheel wheel-front"></div>
        <div className="wheel wheel-back"></div>
        <div className="headlight headlight-right"></div>
        <div className="headlight-glow"></div>
        <div className="taillight taillight-left"></div>
      </div>
      
      <div className="auth-container">
        <ResetPasswordForm />
      </div>
    </div>
  );
};

export default ResetPasswordPage; 